import { type ComponentProps, memo } from 'react'

import View from './Toggle.view'

export type ControllerProps = ComponentProps<typeof View>

export const Controller = memo(function ToggleController(props: ControllerProps) {
  return <View {...props} />
})

Controller.displayName = 'Toggle_Controller'

export default Controller
